<iframe [src]="getPdf()" style="height: 100%; width: 100%;" id="printf"></iframe>
<button (click)="printIframe()">Print</button>

